export default __webpack_public_path__ + "static/media/unhurried.9b81031f.svg";